import React from 'react';
import AddAPhotoIcon from '@mui/icons-material/AddAPhoto';
import { connect } from 'react-redux';
import setImageAction from '../../redux/actions/createReferenceActions/actionImage';
import setUploadReadyAction from '../../redux/actions/createReferenceActions/actionUploadReady';
import Card from '@mui/material/Card';
import CardMedia from '@mui/material/CardMedia';
import IconButton from '@mui/material/IconButton';
import ArrowForwardIos from '@mui/icons-material/ArrowForwardIos';
import ArrowBackIos from '@mui/icons-material/ArrowBackIos';
import DeleteForever from '@mui/icons-material/DeleteForever';
import Alert from '@mui/material/Alert';
import Dialog from '@mui/material/Dialog';
import Tooltip from '@mui/material/Tooltip';
import CardHeader from '@mui/material/CardHeader';
import logo from '../CreateReference/resources/defaultImageCarrousel.jpg';
import { withTranslation } from 'react-i18next';
import Button from '@mui/material/Button';
import { Typography } from '@mui/material';
import AddIcon from '@mui/icons-material/Add';
import RemoveIcon from '@mui/icons-material/Remove';
import setImageUploadErrorAction from '../../redux/actions/createReferenceActions/actionImageUploadError';


class ImageLoader extends React.Component {

    constructor(props) {
        super(props)
        this.state = { selectedFile: [], selectedImage: null, count: 0, open: false, imageCounter: 0, recivedImages: [], uploadReady: true };
        this.handleClick = this.handleClick.bind(this);
        this.handleChange = this.handleChange.bind(this);
        this.handleNextImg = this.handleNextImg.bind(this);
        this.handleBackImg = this.handleBackImg.bind(this);
        this.handleDelete = this.handleDelete.bind(this);
        this.handleCloseDialog = this.handleCloseDialog.bind(this);
        this.handleImgCounter = this.handleImgCounter.bind(this);
        this.handleClickDecrement = this.handleClickDecrement.bind(this)
        this.handleClickIncrement = this.handleClickIncrement.bind(this)

        this.props.setImageFunction('');
        this.props.setUploadReadyFunction(true);
    }

    // Wenn Referenzänderungen folgen, die bereits vorhandenen Bilder vom Server laden und diese
    // an Imageloader übergeben
async componentDidMount() {
    this.props.setImageUploadErrorFunction(false);
    if (this.props.selectedReferenceData && window.location.href.indexOf("/editRef") > -1) {
        let fileArr = [];

        for (const [key, value] of Object.entries(this.props.selectedReferenceData)) {
            if (key.includes("image")) {
                const ordner = this.props.selectedReferenceData.image1.substring(this.props.selectedReferenceData.image1.lastIndexOf('-') + 1, this.props.selectedReferenceData.image1.lastIndexOf('.'));
                const url = `${process.env.REACT_APP_EXPRESS_SERVER}/${ordner}/${value}`;
                //const url = process.env.REACT_APP_EXPRESS_SERVER + '/' + ordner + "/" + value;

                try {
                    const dataUrl = await fetch(url)
                        .then(response => response.blob())
                        .then(blob => new Promise((resolve, reject) => {
                            const reader = new FileReader();
                            reader.onloadend = () => resolve(reader.result);
                            reader.onerror = reject;
                            reader.readAsDataURL(blob);
                        }));

                    let fileData = this.dataURLtoFile(dataUrl, value);
                    fileArr.push(fileData);
                } catch (error) {
                    console.error("Fehler beim Laden und Verarbeiten der Bilder: ", error);
                }
            }
        }

        fileArr.sort((a, b) => (a.name > b.name) ? 1 : -1);
        const selectedImage = URL.createObjectURL(fileArr[0]);
        this.setState({ uploadReady: false, selectedFile: fileArr, selectedImage }, () => {
            this.props.setImageFunction(this.state.selectedFile);
            this.props.setUploadReadyFunction(this.state.uploadReady);
        });
    }
}

dataURLtoFile(dataurl, filename) {
    let arr = dataurl.split(','),
    mime = arr[0].match(/:(.*?);/)[1],
    bstr = atob(arr[1]),
    n = bstr.length,
    u8arr = new Uint8Array(n);
    while (n--) {
        u8arr[n] = bstr.charCodeAt(n);
    }
    
    return new File([u8arr], filename, { type: mime });
}

    // Show/Open filechooser
    handleClick() {
        this.setState({ selectedImage: '' })
        this.refs.fileUploader.click();
        this.setState({ count: 0 })
    }

    async handleChange(event) {
        
        if (event.target.files.length <= 10)  {
            const files = [];
            await Array.from(event.target.files).filter(element => element.name.match(/\.(jpg|JPG|jpeg|JPEG|png|PNG)$/)).forEach(element => {
                files.push(element)
            });

            this.setState({
                selectedFile: [...this.state.selectedFile, ...files]
            }, () => {
                if (this.state.selectedFile.length > 0) {
                    this.setState({
                        selectedImage: URL.createObjectURL(this.state.selectedFile[this.state.count])
                    }, () => {
                        this.props.setImageFunction(this.state.selectedFile)
                    });
                }
            });

        } else {
            this.setState({ open: true });
        }
    }

    // Close Dialog
    handleCloseDialog = () => {
        this.setState({ open: false });

    }

    // ArrowForward handler
    handleNextImg = () => {
        if (this.state.selectedFile !== null) {
            if (this.state.count < this.state.selectedFile.length - 1 && this.state.count >= 0) {
                this.setState({ count: this.state.count + 1 },
                    () => {
                        this.setState({ selectedImage: URL.createObjectURL(this.state.selectedFile[this.state.count]) });
                    })
            }
        }
    }

    // ArrowBack handler
    handleBackImg = () => {
        if (this.state.selectedFile !== null) {
            if (this.state.count <= this.state.selectedFile.length - 1 && this.state.count > 0) {
                this.setState({ count: this.state.count - 1 },
                    () => {
                        this.setState({ selectedImage: URL.createObjectURL(this.state.selectedFile[this.state.count]) });
                    })
            }
        }
    }

    // Delete Image
    handleDelete = () => {

        if (this.state.selectedFile !== null) {
            let myNewFiles = [...this.state.selectedFile];

            myNewFiles.splice(this.state.count, 1);
            this.setState({
                selectedFile: myNewFiles, count: (this.state.count > 1 ? this.state.count-1:  0)
            }, () => {
              
                this.props.setImageFunction(this.state.selectedFile);

                if (this.state.selectedFile.length !== 0) {
                    this.setState({ selectedImage: URL.createObjectURL(this.state.selectedFile[this.state.count]) })
                } else {
                    this.setState({ selectedImage: null })
                }
            });
        }
    }
    
    handleClickDecrement = () => {

        if(this.state.imageCounter < this.state.selectedFile.length-1 && this.state.imageCounter > 1) {
            this.setState({imageCounter: this.state.imageCounter - 1})
        } else {
            this.setState({imageCounter: 0})
        }
    }

    handleClickIncrement = () => {
     
        if(this.state.imageCounter < this.state.selectedFile.length-1) {
            this.setState({imageCounter: this.state.imageCounter + 1})
        } else {
            this.setState({imageCounter: 0})
        }
    }
    
    
    handleImgCounter = () => {
        
        // Array-Index anpassen
        let arr = this.state.selectedFile, x= this.state.count, y= this.state.imageCounter;
        if(this.state.selectedFile.length > this.state.imageCounter ) {
            // elemente swapen
            arr[x] = arr.splice(y, 1, arr[x])[0];
            this.setState({selectedFile: arr, count: this.state.imageCounter, selectedImage: URL.createObjectURL(this.state.selectedFile[this.state.imageCounter])}, () => {
                this.props.setImageFunction(this.state.selectedFile)
            })
        }
    }

    render() {

        const { t } = this.props;

        return (
            <Card style={{ width: 300, margin: 10, backgroundColor: 'rgba(0, 0, 0, 0.4)' }}>

                {this.state.open ?
                    <Dialog onClose={this.handleCloseDialog} aria-labelledby="simple-dialog-title" open={this.state.open}>
                        <Alert severity="error">{t("create_ref.imageloader_error_10")}</Alert>
                    </Dialog>
                    : null}

                {this.props.imageUploadError ? (
                    <Alert severity="error">{t("create_ref.imageloader_error_ammount")}</Alert>
                ) : null}

                <CardHeader subheader={t("create_ref.imageloader_upload_subheader")}
                sx={{
                    ".MuiCardHeader-subheader": {
                        color: 'white',
                    },
                }}  />
                {this.state.selectedImage ? (
                    <CardMedia style={{ height: 0, paddingTop: '56%' }}
                        image={this.state.selectedImage}
                        height="140"
                        title="lorem ipsum"
                    > 
                        <Typography variant="headline" component="h3" align='right' color='secondary' style={{ position: "relative",  top: -40, marginRight: '10px'}}> {this.state.count + 1} </Typography>
                    </CardMedia>
                    
                ) : (
                        <CardMedia style={{ height: 0, paddingTop: '56%' }}
                            image={logo}
                            height="140"
                            title="lorem ipsum"
                        > 
                            <Typography variant="headline" component="h3" align='right' color='secondary' style={{ position: "relative",  top: -40, marginRight: '10px'}}> {this.state.count} </Typography>
                        </CardMedia>
                    )}
                <Tooltip placement="left" title={<h6 style={{ color: "white" }}>Previous image</h6>}>
                    <IconButton style={{ size: 'small' }} aria-label="previousImage" onClick={this.handleBackImg} >
                        <ArrowBackIos style={{ color: 'white' }} />
                    </IconButton>
                </Tooltip>
                <Tooltip placement="left" title={<h6 style={{ color: "white" }}>Upload image</h6>}>
                    <IconButton style={{ color: 'white' }} aria-label="uploadImage" onClick={this.handleClick} onChange={this.handleChange} >
                        <AddAPhotoIcon />
                        <input type="file" key={this.state.theInputKey} accept="image/x-png, image/jpeg" id="file" multiple ref="fileUploader" style={{ display: "none" }} />
                    </IconButton>
                </Tooltip>
                
                <Tooltip placement="left" title={<h6 style={{ color: "white" }}>Delete image</h6>}>
                    <IconButton style={{ color: 'white' }} aria-label="deleteImage" onClick={this.handleDelete} >
                        <DeleteForever />
                    </IconButton>
                </Tooltip>
                <Tooltip placement="left" title={<h6 style={{ color: "white" }}>Next image</h6>}>
                    <IconButton style={{ color: 'white' }} aria-label="nextImage" onClick={this.handleNextImg}  >
                        < ArrowForwardIos />
                    </IconButton>
                </Tooltip>

                <br/>
                <IconButton style={{ color: 'white' }} aria-label="uploadImage" onClick={this.handleClickIncrement}>
                        <AddIcon/>
                </IconButton>
                <Button variant="contained" size="small" color="primary" onClick={this.handleImgCounter} > {t("create_ref.imageloader_upload_order_nr") + " "} { this.state.imageCounter + 1} </Button>
                <IconButton style={{ color: 'white' }} aria-label="uploadImage" onClick={this.handleClickDecrement}>
                        <RemoveIcon />
                </IconButton>

            </Card>

        )
    }
}

function mapStateToProps(state) {
    return {
        imageUploadError: state.createRefState.imageUploadError,
        selectedReferenceData: state.showRefState.selectedReferenceData
    }
}
// set props to redux-store
function mapDispatchToProps(dispatch) {
    return {
        setUploadReadyFunction: uploadReady => {
            dispatch(setUploadReadyAction(uploadReady));
        }, setImageFunction: image => {
            dispatch(setImageAction(image));
        }, setImageUploadErrorFunction: imageUploadError => {
            dispatch(setImageUploadErrorAction(imageUploadError))
        }
    }
}
export default connect(mapStateToProps, mapDispatchToProps)((withTranslation()(ImageLoader)));